import { VariantGroup } from 'pages/special/OsloDesignFair/map/markers/view/VariantIconMarkers/VariantIconMarker/elements/VariantGroup.tsx';
import styled, { CSSProperties } from 'styled-components';

interface VIGroupProps {
    number: number;
    style?: CSSProperties;
    className?: string;
}

export const VIGroup = (props: VIGroupProps) => {
    return (
        <S_VIGroup className={props.className} style={props.style}>
            <VariantGroup number={props.number} />
        </S_VIGroup>
    );
};

const S_VIGroup = styled.div``;
